import React from "react";
import { Chip, CircularProgress, Link, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import {
  useSearchProfiles_SearchLazyQuery,
  SearchProfileOptionFragment,
  SearchProfileType
} from "@graphql";
import { useNavigation } from "@navigation";
import locale from "@bonliva-crm/locale";

type Props = {
  type: SearchProfileType.Consultants;
  onChange: (values: SearchProfileOptionFragment[]) => void;
  defaultValue: SearchProfileOptionFragment[];
  selected: string[];
};

export const SearchProfileMultiSelector: React.FC<Props> = ({
  type,
  onChange,
  defaultValue,
  selected
}) => {
  const [open, setOpen] = React.useState(false);
  const [text, setText] = React.useState("");
  const nav = useNavigation();

  nav.lockNavigation("searchProfileSelector", !!selected);

  const [getOptions, { loading, data }] = useSearchProfiles_SearchLazyQuery();

  const handleSetOptions = () => {
    getOptions({
      variables: {
        filter: {
          text,
          type
        }
      }
    });
  };

  React.useEffect(() => {
    if (!loading) {
      handleSetOptions();
    }
  }, [open, text]);

  const handleChange = async (values) => {
    if (values) {
      onChange(values);
    } else {
      onChange(null);
    }
    setText("");
  };

  return (
    <Autocomplete
      // freeSolo
      defaultValue={defaultValue}
      multiple
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
        setText("");
      }}
      onChange={(e, newValue) => handleChange(newValue)}
      options={data?.SearchProfiles?.items ?? []}
      loading={loading}
      getOptionSelected={(option, value) => option._id === value._id}
      getOptionLabel={(option) => option.name}
      inputValue={text}
      onInputChange={(e, newInputValue) => setText(newInputValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={locale.SearchProfiles}
          fullWidth
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            )
          }}
        />
      )}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            key={index}
            label={
              <Link
                color={"inherit"}
                target="_blank"
                href={`/consultants?searchProfileId=${option._id}`}
              >
                {option.name}
              </Link>
            }
            {...getTagProps({ index })}
          />
        ))
      }
    />
  );
};
